import styled from "styled-components";

export const AddRoleStyles = styled.div`
  .formHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
